import React, { useEffect, useRef, useState } from 'react';
import { StyledProdsCarousel } from './StyledProdsCarousel';
import SwiperCore, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
import Sketchfab from '@sketchfab/viewer-api';
import { Swiper, SwiperSlide } from 'swiper/react';
import gsap from 'gsap';

SwiperCore.use([Navigation]);

const ProdsCarousel = ({ imgs, children, withIframe, srcIframeArray, isShelfzone }) => {

  const [isOverlayOpen, setIsOverlayOpen] = useState(false)
  let currentIndex = 1;
  const [iframeSrc, setIframeSrc] = useState(null)
  const overlay = useRef(null);

  const handleSwiper = (el) => {
    el.slideNext();
  }

  const handleChange = (el) => {
    if (withIframe) {
      const iframes = document.querySelectorAll('.with-iframe iframe');
    
      currentIndex = el.realIndex;
      const iframeActive = iframes[currentIndex];
      if (iframes.length > 0 && !iframeActive.parentNode.classList.contains('loaded')) {
        loadIframe(iframeActive, currentIndex);
      }
    }
    
  }

  const handleClick  = (url) => {
    setIframeSrc(url)
    const overlay = document.querySelector('.overlay--zoom')
    
    if(!isOverlayOpen){
    
      setIsOverlayOpen(true)
      gsap.to(overlay,{x: 0, ease: "power2.easeInOut", duration: .75})
    }
  }

  const loadIframe = (element, id) => {

    var version = '1.12.1';
    var client = new Sketchfab(version, element);
    var uid = srcIframeArray[id]

    client.init(uid, {
      autospin:0.1,
      autostart:1,
      camera:0,
      transparent:1,
      ui_animations: 0,
      ui_annotations:0,
      scrollwheel:0,
      ui_infos:0,
      ui_stop:0,
      ui_inspector:0,
      ui_watermark_link:0,
      ui_watermark:0,
      ui_ar:0,
      ui_help:0,
      ui_settings:0,
      ui_vr:0,
      ui_fullscreen:0,
      success: function onSuccess(api) {
        api.start();
       
        api.addEventListener( 'viewerready', function() {
          if (id == currentIndex) {
            element.parentNode.classList.add('loaded')
          }
          
        });
      },
      error: function onError() {
          console.log( 'Viewer error' );
      }
    });

  }
  const closeOverlay = () =>  {
    
    const overlay = document.querySelector('.overlay--zoom')
    gsap.to(overlay,{x: '-100%', ease: "power2.easeInOut", duration: .75, onComplete: () => {
      
      setIsOverlayOpen(false)
      setIframeSrc(null)
    }})
  }

  return (
    <React.Fragment>
      {
       
          <StyledProdsCarousel isShelfzone={isShelfzone}>
            <div className="overlay--zoom" ref={overlay}>
              <div className="close--overlay" onClick={() => closeOverlay()}>
                <img src={require('../../assets/close-overlay-black.png')} />
              </div>
              <iframe src={iframeSrc} />
            </div>
            <Swiper 
              slidesPerView={'auto'}
              spaceBetween={0}
              navigation
              className="carousel-prods--slider"
              centeredSlides= {true}
              onSwiper={(swiper) => handleSwiper(swiper)}
              onSlideChange={(swiper) => handleChange(swiper)}
              preventInteractionOnTransition={true}
              noSwipingClass="with-iframe"
              >
                {
                  !withIframe &&
                  imgs.map((key, index) => {
                    var i = index;
                    return <SwiperSlide key={index}>
                              <div className="carousel-prods--img" onClick={() => !isShelfzone && handleClick(key.iframeUrl)}>
                                <img src={key.thumb} />
                                {
                                  !isShelfzone &&
                                  <p className="base mobile-tap">View</p>
                                }
                              </div>
                           </SwiperSlide>
                  })
                }
                {
                  withIframe &&
                  srcIframeArray.map((key, index) => {
                    var i = index;
                    return <SwiperSlide key={index} className="with-iframe">
                            <div className='slide--content'>
                              <div className='miniloader-wrap'>
                                <div className="lds-dual-ring"></div>
                                <p>loading 3D model</p>
                              </div>
                              <iframe id={key} loading="lazy"/>
                              <img className="placeholder" src={require(`../../assets/3dcommerce-carousel/carousel-placeholder-0${index + 1}.jpg`)} />
                            </div>
                           </SwiperSlide>
                  })
                }
              </Swiper>
              {
                children
              }
              
          </StyledProdsCarousel>
          
      }
    </React.Fragment>
  );
};

export default ProdsCarousel;